import ComposeBottom from './ComposeBottom';
import { ComposeViewState } from 'owa-mail-compose-store';
import { findComposePlugins } from 'owa-mail-compose-actions/lib/plugins/ComposePlugins';
import { InitialActions } from 'owa-initial-actions';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { VisibilityProperty } from 'csstype';

const styles = require('./Dock.scss');
const classNames = require('classnames/bind').bind(styles);

export interface DockProps {
    viewState: ComposeViewState;
    initialActions: InitialActions;
}

const Dock = observer(function Dock(props: DockProps) {
    const viewState = props.viewState;

    if (viewState.docking.useStickyDocking) {
        return null;
    }

    const dockingViewState = viewState.docking;
    const bottomDockInlineStyles = {
        width: dockingViewState.dockingWidth,
        left: -dockingViewState.scrollLeft,
        bottom: dockingViewState.scrollBarHeight + dockingViewState.bottomDockingBottom,
        visibility: (dockingViewState.isBottomDocking ? 'visible' : 'hidden') as VisibilityProperty,
    };
    const plugins = findComposePlugins(viewState);
    return (
        <div
            style={bottomDockInlineStyles}
            className={classNames(styles.dockContainer, styles.bottomPart, {
                isInlineCompose: viewState.isInlineCompose,
            })}>
            <ComposeBottom
                plugins={plugins}
                isHidden={!dockingViewState.isBottomDocking}
                {...props}
            />
        </div>
    );
});
export default Dock;
